<template>
  <v-btn
    text
    :outlined="outlined"
    :to="path"
    class="my-0"
    style="border-color: darkgray"
    :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
  >
    <v-icon left>{{ icon }}</v-icon>
    {{ title }}
  </v-btn>
</template>

<script>
export default {
  name: "home-menu-card-action-btn",
  props: {
    path: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    outlined: {
      type: Boolean
    }
  }
};
</script>

<style scoped>
</style>